import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
    Box,
  Card,
  CardHeader,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { GeneralAddonForm } from "./components/generalAddonForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";


const AddGeneralAddon = () => {

  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const handleAddAddon = async (addonData) => {
    const payload = {
        name: addonData?.name,
        description: addonData?.description,
        autoApply: addonData?.autoApply,
        mandatory: addonData?.mandatory,
        isActive: addonData?.isActive,
        productId: addonData?.productId?.value,
        policyTypeId: addonData?.policyTypeId?.value
    };
    setCircleLoading(true);
    try {
      const response = await postData("/reference/general/addons/", payload);
      const successResponse = response?.success;
      if(successResponse){
        showSnackbar(response?.message,"success");
        navigate("/general-master/general-addon");
      }
      else{
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      console.error("Error Submitting Data",error);
      showSnackbar(error?.response?.data?.message,"error")
    } finally{
      setCircleLoading(false);
    }         
  };

  return (
    <DashboardLayout>
      <Card sx={{ minHeight: 500 }}>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-addon")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Addon details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add Addon details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralAddonForm onsubmit={handleAddAddon} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddGeneralAddon;
